import { useState, useEffect } from "react";
import {
  Button,
  Box,
  TextField,
  Autocomplete,
  Checkbox,
  FormControlLabel,
  Avatar,
} from "@mui/material";
import { UsePaymentManagment } from "./UsePaymentManagment";
import { useNavigate, useLocation } from "react-router-dom";
import ProgressCom from "../../components/ProgressCom";
import Detail from "../../main/detail/Detail";
import { rsProgress, rsActiveMenu } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import useBreakpoints from "../../hooks/useBreakpoints";

export default function EditPayment(props) {
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const [progress, setProgress] = useRecoilState(rsProgress);
  const navigate = useNavigate();
  const location = useLocation();
  const [orgenizeRes, setOrgenizeRes] = useState();
  const { UpdatePaymentManagment } = UsePaymentManagment();
  const { isSmall } = useBreakpoints();

  const [state, setState] = useState({
    id: undefined,
    icon: undefined,
    index: undefined,
    payment: undefined,
    enable: false,
    description: undefined,
  });

  const [imgState, setImgState] = useState({
    file: undefined,
    url: undefined,
  });

  const handleChangeImage = (e) => {
    setImgState({
      ...imgState,
      file: e.target.files[0],
      url: URL.createObjectURL(e.target.files[0]),
    });
  };

  useEffect(() => {
    if (location.state && location.state.model) {
      setImgState({ ...imgState, url: location.state.model.icon });
      setState({
        id: location.state.model.id,
        payment: location.state.model.payment,
        enable: location.state.model.enable,
        description: location.state.model.description,
        index: location.state.model.index,
      });
    }
  }, [location.state]);

  return (
    <Detail
      breadChilds={{
        title: "مارکتینگ",
        childs: [
          { name: msActiveMenu.pageTitle, url: "/b2bcustomers" },
          { name: "ویرایش مشتری", url: "/b2bcustomers/editCustomer" },
        ],
      }}
    >
      {state ? (
        <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={3}>
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <TextField
              fullWidth
              disabled
              value={state.payment ? state.payment : ""}
              label="روش پرداخت"
              size="small"
              variant="outlined"
              onChange={(evt) => {
                setState({ ...state, payment: evt.target.value });
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 9"></Box>}
          <Box gridColumn={isSmall ? "span 12" : "span 6"}>
            <TextField
              fullWidth
              value={state.description ? state.description : ""}
              label="توضیحات"
              multiline
              maxRows={3}
              size="small"
              variant="outlined"
              onChange={(evt) => {
                setState({ ...state, description: evt.target.value });
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 6"></Box>}
          <Box gridColumn={isSmall ? "span 12" : "span 5"} component="label">
            <Avatar
              sx={{
                border: "1px solid #d9d9d9",
                borderRadius: 3,
                width: "100px",
                height: "100px",
                p: 1,
              }}
              src={imgState.url ? imgState.url : "/static/img/no-photos.png"}
              alt="img"
            />
            <input
              type="file"
              id="img"
              name="avatarName"
              accept="image/*"
              multiple
              onChange={handleChangeImage}
              hidden
            />
          </Box>
          {!isSmall && <Box gridColumn="span 7"></Box>}
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <FormControlLabel
              checked={state.enable ? state.enable : false}
              onChange={(evt) => {
                setState({ ...state, enable: evt.target.checked });
              }}
              control={<Checkbox sx={{ py: 0 }} />}
              label="فعال"
            />
          </Box>
          {!isSmall && <Box gridColumn="span 9"></Box>}
          <Box
            gridColumn={isSmall ? "span 12" : "span 3"}
            sx={{ display: "flex", justifyContent: "flex-end" }}
          >
            <Button
              sx={{ mr: 2, width: "100px" }}
              variant="contained"
              color="secondary"
              onClick={() => {
                setProgress(true);
                UpdatePaymentManagment(state, imgState.file, () => {
                  navigate("/paymentmanagment", {
                    state: { ...location.state, isBack: true },
                    replace: true,
                  });
                });
              }}
            >
              ثبت
            </Button>
            <Button
              sx={{ width: "100px" }}
              variant="outlined"
              color="secondary"
              onClick={() => {
                navigate("/paymentmanagment", {
                  state: { ...location.state, isBack: true },
                  replace: true,
                });
              }}
            >
              بازگشت
            </Button>
          </Box>
          {!isSmall && <Box gridColumn="span 9"></Box>}
        </Box>
      ) : (
        <ProgressCom></ProgressCom>
      )}
    </Detail>
  );
}
